
export default {
  name: "Navigation"
};
